import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import BodyView from "@/layout/BodyView.vue"
import AuthView from "@/components/common/block/auth/AuthView.vue"
import ResetPasswordFirstPage from "@/components/common/block/auth/ResetPasswordFirstPage.vue"
import LoginPage from "@/components/common/block/auth/LoginPage.vue"
import indexDefault from "@/pages/dashbords/indexDefault.vue"
import indexProject from "@/pages/dashbords/indexProject.vue"
import loginSimple from "@/pages/authentication/loginSimple.vue"
import loginImage from "@/pages/authentication/loginImage.vue"
import loginImageTwo from "@/pages/authentication/loginImageTwo.vue"
import loginValidation from "@/pages/authentication/loginValidation.vue"
import loginTooltip from "@/pages/authentication/loginTooltip.vue"
import loginSweetalert from "@/pages/authentication/loginSweetalert.vue"
import registerSimple from "@/pages/authentication/registerSimple.vue"
import registerImage from "@/pages/authentication/registerImage.vue"
import registerImageTwo from "@/pages/authentication/registerImageTwo.vue"
import unlockUser from "@/pages/authentication/unlockUser.vue"
import forgetPassword from "@/pages/authentication/forgetPassword.vue"
import resetPassword from "@/pages/authentication/resetPassword.vue"
import maintenanceView from "@/pages/authentication/maintenanceView.vue"
import AddPermissionPage from "@/pages/Permission/AddPermissionPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import ListeConditionnementPage from "@/pages/GesCom/Conditionnement/ListeConditionnementPage.vue"


import ListeMotifSuiviPage from '@/pages/GesCom/MotifSuivi/ListeMotifSuiviPage.vue';

import AddRolePage from "@/pages/Role/AddRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import AddUserPage from '@/pages/Users/AddUserPage.vue';
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import EditProfilePage from "@/pages/Users/EditProfilePage.vue";
import ViewUserPage from "@/pages/Users/ViewUserPage.vue";
import TableauBordPage from "@/pages/dashbords/TableauBordPage.vue"

//Gescom
import ListeFamillePage from "@/pages/GesCom/Familles/ListeFamillePage.vue";
import AddProduitPage from "@/pages/GesCom/Produit/AddProduitPage.vue";
import EditProduitPage from "@/pages/GesCom/Produit/EditProduitPage.vue";
import ListeProduitPage from "@/pages/GesCom/Produit/ListeProduitPage.vue";
import ViewProduitPage from "@/pages/GesCom/Produit/ViewProduitPage.vue";
import ListeMagasinPage from "@/pages/GesCom/Magasin/ListeMagasinPage.vue";
import AddInventairePage from "@/pages/GesCom/Inventaire/AddInventairePage.vue";

import AddPointVentePage from "@/pages/GesCom/PointVente/AddPointVentePage.vue";
import EditPointVentePage from "@/pages/GesCom/PointVente/EditPointVentePage.vue";
import ListePointVentePage from "@/pages/GesCom/PointVente/ListePointVentePage.vue";
import MiseAJourInventairePage from '@/pages/GesCom/Inventaire/MiseAJourInventairePage.vue';
import ListeProduitIventairePage from '@/pages/GesCom/Inventaire/ListeProduitIventairePage.vue';
// import ListeRapportInventairePage from '@/pages/GesCom/Inventaire/ListeRapportInventairePage.vue';
import ListeInventairePage from '@/pages/GesCom/Inventaire/ListeInventairePage.vue';
import ListeFicheInventairePage from '@/pages/GesCom/Inventaire/ListeFicheInventairePage.vue';
import EditeFicheInventairePage from "@/pages/GesCom/Inventaire/EditeFicheInventairePage.vue";


//Etats
import DetailInventairePage from "@/pages/GesCom/Inventaire/DetailInventairePage.vue";

import ApiService from '@/services/ApiService';

//Fin GesCom/

import { useAuthStore } from "@/services/auth";
import AddClientPage from '@/pages/GesCom/Client/AddClientPage.vue'
import EditClientPage from '@/pages/GesCom/Client/EditClientPage.vue'
import ListeClientPage from '@/pages/GesCom/Client/ListeClientPage.vue'
import ListeCodificationPage from '@/pages/GesCom/Codification/ListeCodificationPage.vue'
import AddProduitConditionnementPage from '@/pages/GesCom/Produit/AddProduitConditionnementPage.vue'
import EditFournisseurPage from '@/pages/GesCom/Fournisseur/EditFournisseurPage.vue'
import ListeFournisseurPage from '@/pages/GesCom/Fournisseur/ListeFournisseurPage.vue'
import AddFournisseurPage from '@/pages/GesCom/Fournisseur/AddFournisseurPage.vue'
import ViewFournisseurPage from '@/pages/GesCom/Fournisseur/ViewFournisseurPage.vue'
import AddCreancePage from '@/pages/GesCom/Creance/AddCreancePage.vue'
import ListeCreancePage from '@/pages/GesCom/Creance/ListeCreancePage.vue'
import EditCreancePage from '@/pages/GesCom/Creance/EditCreancePage.vue'
import ViewCreancePage from '@/pages/GesCom/Creance/ViewCreancePage.vue'
//import ListeClientPage from '@/pages/GesCom/Client/ListeClientPage.vue'
import AddModeReglementModal from '@/components/GesCom/ModeReglement/AddModeReglementModal.vue'
import ListeModeReglement from '@/components/GesCom/ModeReglement/ListeModeReglement.vue'
import AddBanquePage from '@/pages/GesCom/Banque/AddBanquePage.vue'
import ListeBanquePage from '@/pages/GesCom/Banque/ListeBanquePage.vue'

import ListePiecePage from '@/pages/GesCom/Piece/ListePiecePage.vue'
import AddPiecePage from '@/pages/GesCom/Piece/AddPiecePage.vue'
import AddClientAffecterPage from '@/pages/GesCom/ClientAffecter/AddClientAffecterPage.vue'
import ListeClientAffecterPage from '@/pages/GesCom/ClientAffecter/ListeClientAffecterPage.vue'
import EditClientAffecterPage from '@/pages/GesCom/ClientAffecter/EditClientAffecterPage.vue'
import AddMagasinPage from '@/pages/GesCom/Magasin/AddMagasinPage.vue'
import EditMagasinPage from '@/pages/GesCom/Magasin/EditMagasinPage.vue'
import AddVentePage from '@/pages/GesCom/Vente/AddVentePage.vue'
import ListeVentePage from '@/pages/GesCom/Vente/ListeVentePage.vue'
import ViewVentePage from '@/pages/GesCom/Vente/ViewVentePage.vue'
import EtatProduitsDisponibles from '@/pages/GesCom/Etats/EtatProduitsDisponibles.vue'
import EtatChiffreAffaireClientPage from '@/pages/GesCom/Etats/EtatChiffreAffaireClientPage.vue'
import EtatPointVentePage from '@/pages/GesCom/Etats/EtatPointVentePage.vue'
import EtatProduitsRupturePage from '@/pages/GesCom/Etats/EtatProduitsRupturePage.vue'
import EtatProduitsEntreePage from '@/pages/GesCom/Etats/EtatProduitsEntreePage.vue'
import EtatProduitsSortiesPage from '@/pages/GesCom/Etats/EtatProduitsSortiesPage.vue'
import EtatCommandesParUtilisateurPage from '@/pages/GesCom/Etats/EtatCommandesParUtilisateurPage.vue'
import AddSortiePage from '@/pages/GesCom/Sortie/AddSortiePage.vue'
import EditSortiePage from '@/pages/GesCom/Sortie/EditSortiePage.vue'
import ListeSortiePage from '@/pages/GesCom/Sortie/ListeSortiePage.vue'
import ViewSortiePage from '@/pages/GesCom/Sortie/ViewSortiePage.vue'
import AddApprovisionnementPage from '@/pages/GesCom/Approvisionnement/AddApprovisionnementPage.vue'
import ListeApprovisionnementPage from '@/pages/GesCom/Approvisionnement/ListeApprovisionnementPage.vue'
import ViewApprovisionnementPage from '@/pages/GesCom/Approvisionnement/ViewApprovisionnementPage.vue'
import AddCaissePage from '@/pages/GesCom/Caisse/AddCaissePage.vue'
import AddFermPage from '@/pages/GesCom/OuvFerm/AddFermPage.vue'
import AddOuvFermPage from '@/pages/GesCom/OuvFerm/AddOuvFermPage.vue'
import ListeCaissePage from '@/pages/GesCom/Caisse/ListeCaissePage.vue'
import ViewOuvFermPage from '@/pages/GesCom/OuvFerm/ViewOuvFermPage.vue'
import ListeOuvFermPage from '@/pages/GesCom/OuvFerm/ListeOuvFermPage.vue'
import ListeCategorieClientPage from '@/pages/GesCom/CategorieClient/ListeCategorieClientPage.vue'
import AddPaiementPage from '@/pages/GesCom/Paiement/AddPaiementPage.vue'
import ListePaiementPage from '@/pages/GesCom/Paiement/ListePaiementPage.vue'
import ViewPaiementPage from '@/pages/GesCom/Paiement/ViewPaiementPage.vue'
import EditSocietePage from '@/pages/GesCom/Societe/EditSocietePage.vue'
import ListeSocietePage from '@/pages/GesCom/Societe/ListeSocietePage.vue'
import ViewSocietePage from '@/pages/GesCom/Societe/ViewSocietePage.vue'
import AddSocietePage from '@/pages/GesCom/Societe/AddSocietePage.vue'
import AddPersonnellePage from '@/pages/GesCom/Personnel/AddPersonnellePage.vue'
import ListePersonnellePage from '@/pages/GesCom/Personnel/ListePersonnellePage.vue'
import ViewPersonnellePage from '@/pages/GesCom/Personnel/ViewPersonnellePage.vue'
import EditPersonnellePage from '@/pages/GesCom/Personnel/EditPersonnellePage.vue'
import EditPersonnellePage2 from '@/pages/GesCom/Personnel/EditPersonnellePage2.vue'
import AddModeleSignatairePage from '@/pages/GesCom/ModeleSignataire/AddModeleSignatairePage.vue'
import ListeModeleSignatairePage from '@/pages/GesCom/ModeleSignataire/ListeModeleSignatairePage.vue'
import ListFonctionPage from '@/pages/GesCom/Fonction/ListFonctionPage.vue'
import AddFonctionPage from '@/pages/GesCom/Fonction/AddFonctionPage.vue'
import ConfirmationPaiementPage from '@/pages/GesCom/OuvFerm/ConfirmationPaiementPage.vue'
import ListeTypeDocumentPage from '@/pages/GesCom/TypeDocument/ListeTypeDocumentPage.vue'
import AddTypeDocumentModalPage from '@/pages/GesCom/TypeDocument/AddTypeDocumentModalPage.vue'
import ConversionMonnaiePage from '@/pages/GesCom/Operations/ConversionMonnaiePage.vue'
import AddDecaissementPage from '@/pages/GesCom/Operations/AddDecaissementPage.vue'
import AddEncaissementPage from '@/pages/GesCom/Operations/AddEncaissementPage.vue'
import ListeOperationPage from '@/pages/GesCom/Operation/ListeOperationPage.vue'
import AffectationCaisseModalPage from '@/pages/GesCom/AffectationCaisse/AffectationCaisseModalPage.vue'
import EditAffectationCaissePage from '@/pages/GesCom/AffectationCaisse/EditAffectationCaissePage.vue'
import HistoriquePage from '@/pages/GesCom/AffectationCaisse/HistoriquePage.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: BodyView,
    meta: {
    title: 'ROMAS SIG',
    },
    children: [
      {
        path: '',
        name: 'TableauBord',
        component: TableauBordPage,
        meta: {
          title: 'ROMAS SIG',
        }
      }
    ]
  },
  {
    path: "/accueil",
    component: BodyView,
    children: [
      {
        path: "tableau-bord",
        name: "TableauBord",
        component: TableauBordPage,
        meta: {
          title: 'Tableau de bord',
        }
      },
    ]
  },

  {
    path: "/utilisateurs",
    component: BodyView,
    children: [
      {
        path: "ajouter-utilisateur",
        name: "AddUser",
        component: AddUserPage,
        meta: {
          title: 'Ajouter un utilisateur',
        }
      },
      {
        path: "liste-utilisateur",
        name: "ListeUser",
        component: ListeUserPage,
        meta: {
          title: 'Liste des utilisateurs',
        }
      },
      {
        path: "edit-utilisateur/:id",
        name: "EditUser",
        component: EditUserPage,
        meta: {
          title: 'Modifier un utilisateur',
        }
      },
      {
        path: "view-utilisateur/:id",
        name: "ViewUser",
        component: ViewUserPage,
        meta: {
          title: 'Détails d\'un utilisateur',
        }
      },
    ]
  },

  // {
  //   path: "/motifSuivis",
  //   component: BodyView,
  //   children: [
  //     {
  //       path: "liste-motifSuivi",
  //       name: "ListeMotifSuivi",
  //       component: ListeMotifSuiviPage,
  //       meta: {
  //         title: 'Liste des motifs Suivis',
  //       }
  //     },
  //   ]
  // },
  {
    path: "",
    component: BodyView,
    children: [
      {
        path: "profile",
        name: "EditProfile",
        component: EditProfilePage,
        meta: {
          title: 'Modifier mon profile',
        }
      }
    ]
  },
  {
    path: "/clients",
    component: BodyView,
    children: [
      {
        path: "ajouter-client",
        name: "AddClient",
        component: AddClientPage,
        meta: {
          title: 'Ajouter un client',
        }
      },
      {
        path: "modifier-client/:id",
        name: "EditClient",
        component: EditClientPage,
        meta: {
          title: 'Modifier un client',
        }
      },
      {
        path: "liste-clients",
        name: "ListeClient",
        component: ListeClientPage,
        meta: {
          title: 'Liste des clients',
        }
      }
    ]
  },
  {
    path: "/categorieclients",
    component: BodyView,
    children: [
      {
        path: "liste-categorieclients",
        name: "ListeCategorieClient",
        component: ListeCategorieClientPage,
        meta: {
          title: 'Liste des categories clients',
        }
      },
    ]
  },

   {
    path: "/paiements",
    component: BodyView,
    children: [
      {
        path: "ajouter-paiement",
        name: "AddPaiement",
        component: AddPaiementPage,
        meta: {
          title: 'Ajouter un paiement',
        }
      },
      // {
      //   path: "modifier-paiement/:id",
      //   name: "EditPaiement",
      //   component: EditPaiementPage,
      //   meta: {
      //     title: 'Modifier un paiement',
      //   }
      // },
      {
        path: "liste-paiements",
        name: "ListePaiement",
        component: ListePaiementPage,
        meta: {
          title: 'Liste des paiements',
        }
      },
      // {
      //   path: "liste-mode-paiement",
      //   name: "ListeModePaiement",
      //   component: ListeModePaiementPage,
      //   meta: {
      //     title: 'Liste des modes de paiement',
      //   }
      // },
      {
        path: "view-Paiement/:id",
        name: "ViewPaiement",
        component: ViewPaiementPage,
        meta: {
          title: 'Détails d\'un paiement',
        }
      },
    ]
  },
  {
    path: "/fiches",
    component: BodyView,
    children: [
      /*{
        path: "modifier-fiche/:id",
        name: "EditFiche",
        component: EditFichePage,
        meta: {
          title: 'Modifier une fiche',
        }
      },*/
      /* {
         path: "view-client/:id",
         name: "ViewClient",  
         component: ViewClientPage,
         meta: {
           title: 'Détails d\'un client',
         }
       },*/
    ]
  },
  // {
  //   path: "/rapportInventaire",
  //   component: BodyView,
  //   children: [
  //     {
  //       path: "liste-rapportInventaires",
  //       name: "liste-rapportInventaires",
  //       component: ListeRapportInventairePage,
  //       meta: {
  //         title: 'Liste Rapport Inventaire',
  //       }
  //     },
  //   ]
  // },

  {
    path: "/permissions",
    component: BodyView,
    children: [
      {
        path: "ajouter-permission",
        name: "AddPermissionPage",
        component: AddPermissionPage,
        meta: {
          title: 'Ajouter une permission',
        }
      },
      {
        path: "liste-permission",
        name: "ListePermissionPage",
        component: ListePermissionPage,
        meta: {
          title: 'Liste des permissions',
        }
      }
    ]
  },



  {
    path: "/roles",
    component: BodyView,
    children: [
      {
        path: "ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
        meta: {
          title: 'Ajouter un role',
        }
      },
      {
        path: "liste-role",
        name: "ListeRolePage",
        component: ListeRolePage,
        meta: {
          title: 'Liste des rôles',
        }
      },
      {
        path: "edit-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
        meta: {
          title: 'Modifier un rôle',
        }
      },
      {
        path: "view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
        meta: {
          title: 'Détails du rôle',
        }
      }
    ]
  },
  {
    path: "/familles",
    component: BodyView,
    children: [
      {
        path: "liste-familles",
        name: "ListeFamille",
        component: ListeFamillePage,
        meta: {
          title: 'Liste des familles',
        }
      },
    ]
  },

  {
    path: "/produits",
    component: BodyView,
    children: [
      {
        path: "ajouter-produit",
        name: "AddProduit",
        component: AddProduitPage,
        meta: {
          title: 'Ajouter un produit',
        }
      },
      {
        path: "modifier-produit/:id",
        name: "EditProduit",
        component: EditProduitPage,
        meta: {
          title: 'Modifier un produit',
        }
      },
      {
        path: "view-produit/:id",
        name: "ViewProduit",
        component: ViewProduitPage,
        meta: {
          title: 'Détails d\'un produit',
        }
      },
      {
        path: "liste-produits",
        name: "ListeProduit",
        component: ListeProduitPage,
        meta: {
          title: 'Liste des produits',
        }
      },
      {
        path: '/produits/conditionnement/:id',
        name: 'AddProduitConditionnement',
        component: AddProduitConditionnementPage
      }
    ]
  },
  {
    path: "/magasins",
    component: BodyView,
    children: [
      {
        path: "liste-magasins",
        name: "ListeMagasin",
        component: ListeMagasinPage,
        meta: {
          title: 'Liste des magasins',
        }
      },
      {
        path: "ajouter-magasin",
        name: "AddMagasin",
        component: AddMagasinPage,
        meta: {
          title: 'Ajouter un magasin',
        }
      },
      {
        path: "modifier-magasin/:id",
        name: "EditMagasin",
        component: EditMagasinPage,
        meta: {
          title: 'Modifier un magasin',
        }
      },
    ]
  },
  {
    path: "/banques",
    component: BodyView,
    children: [
      {
        path: "ajouter-banque",
        name: "AddBanque",
        component: AddBanquePage,
        meta: {
          title: 'Ajouter une banque',
        }
      },

      {
        path: "liste-banques",
        name: "ListeBanque",
        component: ListeBanquePage,
        meta: {
          title: 'Liste des banques',
        }
      },
    ]
  },
  {
    path: "/pieces",
    component: BodyView,
    children: [
      {
        path: "ajouter-piece",
        name: "AddPiece",
        component: AddPiecePage,
        meta: {
          title: 'Ajouter une pièce',
        }
      },

      {
        path: "liste-pieces",
        name: "ListePiece",
        component: ListePiecePage,
        meta: {
          title: 'Liste des pièces',
        }
      },
    ]
  },
  {
    path: "/inventaires",
    component: BodyView,
    children: [
      {
        path: "ajouter-inventaire",
        name: "AddInventaire",
        component: AddInventairePage,
        meta: {
          title: 'Ajouter un inventaire',
        }
      },
      {
        path: "edite-fiche-inventaire/:id",
        name: "EditeFicheInventaire",
        component: EditeFicheInventairePage,
        meta: {
          title: 'Edite fiche inventaire',
        }
      },

      {
        path: "detail-inventaire/:id",
        name: "DetailInventairePage",
        component: DetailInventairePage,
        meta: {
          title: 'Détail inventaire',
        }
      },
      {
        path: "inventorier",
        name: "MiseAJourInventaire",
        component: MiseAJourInventairePage,
        meta: {
          title: 'Inventorier',
        }
      },
      {
        path: "liste-fiche-inventaires",
        name: "ListeFicheInventaire",
        component: ListeFicheInventairePage,
        meta: {
          title: 'Liste des fiches d\'inventaires',
        }
      },

      {
        path: "liste-inventaires",
        name: "ListeInventaire",
        component: ListeInventairePage,
        meta: {
          title: 'Liste des inventaires',
        }
      },


      {
        path: "liste-produit-inventaire",
        name: "ListeProduitIventaire",
        component: ListeProduitIventairePage,
        meta: {
          title: 'Liste des produits inventoriers',
        }
      },
    ]
  },
  {
    path: "/fournisseurs",
    component: BodyView,
    children: [
      {
        path: "ajouter-fournisseur",
        name: "AddFournisseur",
        component: AddFournisseurPage,
        meta: {
          title: 'Ajouter un fournisseur',
        }
      },

      {
        path: "edit-fournisseur/:id",
        name: "EditFournisseur",
        component: EditFournisseurPage,
        meta: {
          title: 'Modifier un fournisseur',
        }
      },
      {
        path: "liste-fournisseurs",
        name: "ListeFournisseur",
        component: ListeFournisseurPage,
        meta: {
          title: 'Liste des fournisseurs',
        }
      },
      {
        path: "view-fournisseur/:id",
        name: "ViewFournisseur",
        component: ViewFournisseurPage,
        meta: {
          title: 'Détails d\'un fournisseur',
        }
      },

    ]
  },

  {
    path: "/ventes",
    component: BodyView,
    children: [
      {
        path: "ajouter-vente",
        name: "AddVente",
        component: AddVentePage,
        meta: {
          title: 'Ajouter une vente',
        }
      },
      {
        path: "liste-ventes",
        name: "ListeVente",
        component: ListeVentePage,
        meta: {
          title: 'Liste des ventes',
        }
      },
      {
        path: "view-Vente/:id",
        name: "ViewVente",
        component: ViewVentePage,
        meta: {
          title: 'Détails d\'une vente',
        }
      },

    ]
  },

  {
    path: "/etats",
    component: BodyView,
    children: [
      {
        path: "produits-disponibles",
        name: "EtatProduitsDisponibles",
        component: EtatProduitsDisponibles,
        meta: {
          title: 'Stock du produit',
        }
      },
      {
        path: "ca-client",
        name: "EtatChiffreAffaireClientPage",
        component: EtatChiffreAffaireClientPage,
        meta: {
          title: `Chiffre d'affaire par Client`,
        }
      },
      {
        path: "produits-vendus",
        name: "EtatPointVentePage",
        component: EtatPointVentePage,
        meta: {
          title: 'Liste des produits vendus',
        }
      },
      {
        path: "produits-rupture",
        name: "EtatProduitsRupturePage",
        component: EtatProduitsRupturePage,
        meta: {
          title: 'Liste des produits en rupture de stock',
        }
      },
      {
        path: "etat-produits-entree",
        name: "EtatProduitsEntreePage",
        component: EtatProduitsEntreePage,
        meta: {
          title: 'Liste des produits entrées',
        }
      },
      {
        path: "etats-produits-sorties",
        name: "EtatProduitsSortiesPage",
        component: EtatProduitsSortiesPage,
        meta: {
          title: 'Liste des produits sorties',
        }
      },
      {
        path: "commandes-par-utilisateur",
        name: "EtatCommandesParUtilisateurPage",
        component: EtatCommandesParUtilisateurPage,
        meta: {
          title: 'Commandes par utilisateur',
        }
      },
    ]
  },

  {
    path: "/sorties",
    component: BodyView,
    children: [
      {
        path: "ajouter-sortie",
        name: "AddSortie",
        component: AddSortiePage,
        meta: {
          title: 'Ajouter une sortie',
        }
      },
      {
        path: "modifier-sortie/:id",
        name: "EditSortie",
        component: EditSortiePage,
        meta: {
          title: 'Modifier une sortie',
        }
      },
      {
        path: "liste-sorties",
        name: "ListeSortie",
        component: ListeSortiePage,
        meta: {
          title: 'Liste des sorties',
        }
      },
      {
        path: "view-sortie/:id",
        name: "ViewSortie",
        component: ViewSortiePage,
        meta: {
          title: 'Détails d\'une sortie',
        }
      },
    ]
  },
  {
    path: "/approvisionnements",
    component: BodyView,
    children: [
      {
        path: "ajouter-approvisionnement",
        name: "AddApprovisionnement",
        component: AddApprovisionnementPage,
        meta: {
          title: 'Ajouter un approvisionnement',
        }
      },
      {
        path: "liste-approvisionnements",
        name: "ListeApprovisionnement",
        component: ListeApprovisionnementPage,
        meta: {
          title: 'Liste des approvisionnements',
        }
      },
      {
        path: "view-approvisionnement/:id",
        name: "ViewApprovisionnement",
        component: ViewApprovisionnementPage,
        meta: {
          title: 'Détails d\'un approvisionnement',
        }
      },
    ]
  },
  {
    path: "/caisses",
    component: BodyView,
    children: [
      {
        path: "ajouter-caisse",
        name: "AddCaisse",
        component: AddCaissePage,
        meta: {
          title: 'Ajouter une caisse',
        }
      },
      //  {
      //   path: "liste-agences",
      //   name: "ListeAgence",
      //   component: ListeAgencePage,
      //   meta: {
      //     title: 'Liste des agences',
      //   }
      // },
      // {
      //   path: "modifier-caisse/:id",
      //   name: "EditCaisse",
      //   component: EditCaissePage,
      //   meta: {
      //     title: 'Modifier une caisse',
      //   }
      // },


        {
        path: "affecter-caisse/:caisseId",
        name: "AffectationCaissePage",
        component: AffectationCaisseModalPage,
        meta: {
          title: 'Affecter une caisse',
        }
      },

      //  {
      //   path: "editer-caisse/:affectationId",
      //   name: "EditAffectationCaissePage",
      //   component: EditAffectationCaissePage,
      //   meta: {
      //     title: 'Modifier une affectation de caisse',
      //   }
      // },

       {
        path: "historique-affectations/:caisseId",
        name: "HistoriquePage",
        component: HistoriquePage,
        meta: {
          title: 'Historique des affectations de caisse',
        }
      },
      


      {
        path: "/OuverturesFermetures",
        name: "ListeOuvFerm",
        component: ListeOuvFermPage,
      },

      {
        path: '/ouverture/:id',
        name: 'ViewOuvFermPage',
        component: ViewOuvFermPage,
      },
       {
        path: '/confirmation',
        name: 'ConfirmationPaiementPage',
        component: ConfirmationPaiementPage,
      },
      {
        path: "liste-caisses",
        name: "ListeCaisse",
        component: ListeCaissePage,
        meta: {
          title: 'Liste des caisses',
        }
      },

      {
        path: "/ajouter-ouvfer",
        name: "AddOuvFermPage",
        component: AddOuvFermPage,
      },
      {
        path: "/ajouter-fer/:id",
        name: "AddFermPage",
        component: AddFermPage,
      },
       {
      path: "/ajouter-encaissement",
      name: "AddEncaissementPage",
      component: AddEncaissementPage,
    },

    {
      path: "/ajouter-decaissement",
      name: "AddDecaissementPage",
      component: AddDecaissementPage,
    },
    {
      path: "/faire-conversion",
      name: "ConversionMonnaiePage",
      component: ConversionMonnaiePage,
    },

    {
      path: "/liste-operations",
      name: "ListeOperationPage",
      component: ListeOperationPage,
    },
    // {
    //   path: "/TypeOperations",
    //   name: "ListeTypeOperation",
    //   component: ListeTypeOperationPage,
    // }

    ]
  },

  

  {
    path: "/personnelles",
    component: BodyView,
    children: [
      {
        path: "ajouter-personnel",
        name: "AddPersonnellePage",
        component: AddPersonnellePage,
        meta: {
          title: 'Ajouter un personnel',
        }
      },
      {
        path: "liste-personnel",
        name: "ListePersonnelPage",
        component: ListePersonnellePage,
        meta: {
          title: 'Liste des personnels',
        },
      },

      {
        path: "view-personnel/:id",
        name: "ViewPersonnellePage",
        component: ViewPersonnellePage,
        meta: {
          title: 'Détail du personnel',
        }
      },
      {
        path: "edit-personnel/:id",
        name: "EditPersonnellePage",
        component: EditPersonnellePage,
        meta: {
          title: 'Modifier un personnel',
        }
      },
      {
        path: "edit-personnel2/:id",
        name: "EditPersonnellePage2",
        component: EditPersonnellePage2,
        meta: {
          title: 'Modifier un personnel',
        }
      }
    ]
  },
  {
    path: "/conditionnements",
    component: BodyView,
    children: [
      {
        path: "liste-conditionnements",
        name: "ListeConditionnement",
        component: ListeConditionnementPage,
        meta: {
          title: 'Liste des conditionnements',
        }
      },

    ]
  },
  {
    path: "/codifications",
    component: BodyView,
    children: [
      {
        path: "liste-codifications",
        name: "ListeCodification",
        component: ListeCodificationPage,
        meta: {
          title: 'Liste des codifications',
        }
      },

    ]
  },
  {
    path: "/ma-societe",
    component: BodyView,
    children: [
      {
        path: "ajouter",
        name: "AddMaSociete",
        component: AddSocietePage,
        meta: {
          title: "Ajouter ma société",
        },
      },
      {
        path: "modifier/:id",
        name: "EditMaSociete",
        component: EditSocietePage,
        meta: {
          title: "Modifier ma société",
        },
      },
      {
        path: "liste",
        name: "ListeMaSociete",
        component: ListeSocietePage,
        meta: {
          title: "",
        },
      },
      {
        path: "details/:id",
        name: "ViewMaSociete",
        component: ViewSocietePage,
        meta: {
          title: "Détails de ma société",
        },
      },
    ],
  },
  {
    path: "/point-ventes",
    component: BodyView,
    children: [
      {
        path: "ajouter-point-vente",
        name: "AddPointVente",
        component: AddPointVentePage,
        meta: {
          title: 'Ajouter un point de vente',
        }
      },
      {
        path: "modifier-point-vente/:id",
        name: "EditPointVente",
        component: EditPointVentePage,
        meta: {
          title: 'Modifier un point de vente',
        }
      },
      {
        path: "liste-point-ventes",
        name: "ListePointVente",
        component: ListePointVentePage,
        meta: {
          title: 'Liste des points de vente',
        }
      },
    ]
  },

  {
    path: "/auth",
    component: AuthView,
    children: [
      {
        path: "login",
        name: "login",
        component: LoginPage,
        meta: {
          title: 'ROMAS - Connexion',
        }
      },
      {
        path: "reset_password_first",
        name: "ResetPasswordFirst",
        component: ResetPasswordFirstPage,
        meta: {
          title: 'Reset Password | ROMAS',
        }
      },
    ]
  },
  {
    path: "/dashboards",
    component: BodyView,
    children: [
      {
        path: "dashboard_default",
        name: "default",
        component: indexDefault,
        meta: {
          title: 'Dashboards | Mofi - Premium Vue Admin Template',
        }
      },
      {
        path: "dashboard_project",
        name: "project",
        component: indexProject,
        meta: {
          title: 'Dashboards CRM | Mofi - Premium Vue Admin Template',
        }
      },
    ]
  },
  {
    path: "/authentication/simple",
    name: "loginsimple",
    component: loginSimple,
    meta: {
      title: 'Login Simple | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/one",
    name: "loginimage",
    component: loginImage,
    meta: {
      title: 'Login Image | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/two",
    name: "loginImagetwo",
    component: loginImageTwo,
    meta: {
      title: 'Login Image Two | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/validate",
    name: "loginValidation",
    component: loginValidation,
    meta: {
      title: 'Login Validation | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/tooltip",
    name: "loginTooltip",
    component: loginTooltip,
    meta: {
      title: 'Login Tooltip | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/sweetalert",
    name: "loginSweetalert",
    component: loginSweetalert,
    meta: {
      title: 'Login Sweetalert | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/register/two",
    name: "registerImagetwo",
    component: registerImageTwo,
    meta: {
      title: 'Register Image Two | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/auth/register",
    name: "registerSimple",
    component: registerSimple,
    meta: {
      title: 'Register | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/register/one",
    name: "registerImage",
    component: registerImage,
    meta: {
      title: 'Register Image | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/unlock_user",
    name: "unlockUser",
    component: unlockUser,
    meta: {
      title: 'Unlock User | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/forget_password",
    name: "forgetPassword",
    component: forgetPassword,
    meta: {
      title: 'Forget Password | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/reset_password",
    name: "resetPassword",
    component: resetPassword,
    meta: {
      title: 'Reset Password | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/maintenance",
    name: "maintenanceView",
    component: maintenanceView,
    meta: {
      title: 'Maintenance | Mofi - Premium Vue Admin Template',
    }
  }
]


/*const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})*/

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHashHistory(),
  linkExactActiveClass: "active",
  routes,
  /*scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },*/
});

router.beforeEach(async (to, from, next) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }
  ApiService.setHeader();
  const authStore = useAuthStore();
  await authStore.verifyAuth();
  const path = ['/auth/login', '/auth/register', '/auth/reset_password_first'];
  if (path.includes(to.path) || authStore.isAuthenticated) {
    next();
  } else {
    next('/auth/login');
  }
});

export default router
